import { css } from '@emotion/react';
import { colors } from 'src/styles/colors';
import { ZeeFontRegular } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';

export const calendarWrapperStyle = css`
  display: flex;
  padding: 0px 16px;
  margin-bottom: 20px;
  justify-content: space-between;
  gap: 10px;
`;

export const calendarButtonWrapperStyle = css`
  overflow: scroll;
  ${MQ.MediaMd} {
    overflow: auto;
  }
  display: flex;
  flex: 92%;
  gap: 10px;
`;
export const calendarFilterButtonStyle = css`
  display: flex;
  cursor: pointer;
  padding: 8px 12px;
  align-items: center;
  gap: 4px;
  border-radius: 999px;
  border: 1px solid ${colors.PaleLavender};
  ${ZeeFontRegular(12, 18)};
`;

export const calendarButtonActiveStyle = css`
  background-color: ${colors.PaleLavender};
  color: ${colors.black};
`;

export const calendarIconStyle = css`
  position: relative;
  display: flex;
  flex: 8%;
`;

export const listWrapperStyle = css`
  position: absolute;
  right: 0px;
  top: 35px;
  background-color: ${colors.RaisinBlack};
  border: 1px solid ${colors.CharcoalPurple};
  border-radius: 6px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  list-style: none;
  margin: 0;
  padding: 10px 10px;
  z-index: 1000;
  width: max-content;
  max-height: 300px;
  overflow: scroll;
`;

export const listItemStyle = css`
  padding: 8px 12px;
  cursor: pointer;
  &:hover {
    background-color: ${colors.BlueViolet};
    border-radius: 6px;
  }
`;

export const closeIconStyle = css`
  display: flex;
  ${ZeeFontRegular(12, 18)};
`;
